export const zendeskData = {
  success: true,
  help: true,
  redirectUrl: 'https://intellihealthcorp.zendesk.com/access/jwt?jwt=asd123',
};
